const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const IST_PARTS = new Intl.DateTimeFormat("en-GB", { timeZone: "Asia/Kolkata", day: "numeric", month: "numeric", year: "numeric" })

/** `d MMM yyyy` in Asia/Kolkata with fixed month names (ICU's en-GB gives "Sept"). */
export function formatIstDate(iso: string): string {
  const parts = Object.fromEntries(IST_PARTS.formatToParts(new Date(iso)).map((p) => [p.type, p.value]))
  return `${Number(parts.day)} ${MONTHS[Number(parts.month) - 1]} ${parts.year}`
}

/** "1 sheet", "2 sheets": the count and the word, with an s unless the count is exactly 1. */
export function plural(n: number, word: string): string {
  return `${n} ${n === 1 ? word : `${word}s`}`
}
